import { track, trackCubeCustomEvent } from '../tracking/trackingLayer';

export default class BewertenVideoLayer extends HTMLElement {
  connectedCallback() {
    this.$layer = this.querySelector('#bewerten-video-modal');
    this.$content = this.$layer.querySelector('.bewerten-video-layer__container');
    this.isOpen = false;
    this.farbId = null;

    this.videoLayerOpenListener = (e) => {
      const {
        videoUrls,
        poster,
        farbId,
      } = e.detail;
      this.show(videoUrls, poster, farbId);
    };

    this.onModalHide = () => {
      if (this.isOpen) {
        this.$content.innerHTML = '';
        this.videoCloseLayer();
        this.isOpen = false;
      }
    };

    this.addEventListener('bewe:ents:videoLayerOpen', this.videoLayerOpenListener);
    this.$layer.addEventListener('ents-modal:close', this.onModalHide);
  }

  disconnectedCallback() {
    this.removeEventListener('bewe:ents:videoLayerOpen', this.videoLayerOpenListener);
    this.$layer.removeEventListener('ents-modal:close', this.onModalHide);
  }

  show(videoUrls, poster, farbId) {
    this.farbId = farbId;
    const source = v => `<source src="${v.url}" type="${v.type}">`;
    const videoSources = videoUrls
      .map(source)
      .join('');
    this.$content.innerHTML = `<video autoplay playsinline loop muted controls poster="${poster}"
        data-test-bewerten-video-layer-video>${videoSources}</video>`;
    this.isOpen = true;

    this.$layer.classList.remove('hidden');
    this.$layer.show();
    this.trackVideoOpenLayer();
  }

  trackVideoOpenLayer() {
    track({
      event_level1: 'ents',
      event_values: ['click', 'video_open'],
      event: 'event.generic',
    });

    trackCubeCustomEvent(
      'video_open',
      {
        event_category: 'video',
        is_interaction_event: true,
        event_type: 'open',
        event_content: [this.farbId],
      },
    );
  }

  videoCloseLayer() {
    track({
      event_level1: 'ents',
      event_values: ['click', 'video_close'],
      event: 'event.generic',
    });

    trackCubeCustomEvent(
      'video_close',
      {
        event_category: 'video',
        is_interaction_event: true,
        event_type: 'close',
        event_content: [this.farbId],
      },
    );
  }
}

document.addEventListener('bewe:ents:vue-ready', () => {
  customElements.define('bewerten-video-layer', BewertenVideoLayer);
}, { once: true });
